import React from 'react';
import Container from '../../components/Container/Container';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Button from '@Theme/natucare/components/Button/Button';
import Icon from '@Theme/natucare/components/Icon/Icon';
import NewsletterForm from '@App/themes/natucare/components/NewsletterForm/NewsletterForm';
import { featureContentPropTypes } from './FeatureContentPropTypes';
import * as styles from './FeatureContent.module.scss';
const FeatureContent = ({
  subheading,
  heading,
  picture,
  text,
  list,
  actions,
  variant
}) => {
  var _actions$button, _actions$button2, _actions$button3, _actions$button4, _actions$newsletterFo, _actions$newsletterFo2, _actions$newsletterFo3;
  if (!subheading && !text && !heading) {
    return false;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${variant ? variant.map(el => styles[`root${el}`]).join(' ') : ''}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCol
  }, subheading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootSubheading
  }, subheading), heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), text && /*#__PURE__*/React.createElement("div", {
    className: styles.rootText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), list && /*#__PURE__*/React.createElement("ul", {
    className: styles.rootList
  }, list.map(({
    icon,
    text
  }, index) => /*#__PURE__*/React.createElement("li", {
    className: styles.rootListItem,
    key: index
  }, (icon === null || icon === void 0 ? void 0 : icon.path) && /*#__PURE__*/React.createElement(Icon, {
    path: icon === null || icon === void 0 ? void 0 : icon.path,
    viewBox: icon === null || icon === void 0 ? void 0 : icon.viewBox,
    classname: styles.rootListItemIcon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rootListItemText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })))), (actions === null || actions === void 0 ? void 0 : (_actions$button = actions.button) === null || _actions$button === void 0 ? void 0 : _actions$button.label) && (actions === null || actions === void 0 ? void 0 : (_actions$button2 = actions.button) === null || _actions$button2 === void 0 ? void 0 : _actions$button2.href) && /*#__PURE__*/React.createElement(Button, {
    classname: styles.rootButton,
    variant: "primaryOrange",
    href: actions === null || actions === void 0 ? void 0 : (_actions$button3 = actions.button) === null || _actions$button3 === void 0 ? void 0 : _actions$button3.href,
    label: actions === null || actions === void 0 ? void 0 : (_actions$button4 = actions.button) === null || _actions$button4 === void 0 ? void 0 : _actions$button4.label
  }), actions.newsletterForm && ((_actions$newsletterFo = actions.newsletterForm) === null || _actions$newsletterFo === void 0 ? void 0 : _actions$newsletterFo.placeholder) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootNewsletterForm
  }, /*#__PURE__*/React.createElement(NewsletterForm, {
    variant: "FeatureContent",
    buttonLabel: (_actions$newsletterFo2 = actions.newsletterForm) === null || _actions$newsletterFo2 === void 0 ? void 0 : _actions$newsletterFo2.label,
    classname: actions.newsletterForm.classname,
    placeholder: actions.newsletterForm.placeholder,
    subscriptionStatus: actions === null || actions === void 0 ? void 0 : (_actions$newsletterFo3 = actions.newsletterForm) === null || _actions$newsletterFo3 === void 0 ? void 0 : _actions$newsletterFo3.subscriptionStatus,
    onSubscribe: actions.newsletterForm.onSubscribe,
    consent: actions.newsletterForm.consent
  }))), picture && picture.xs && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCol
  }, /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.xs
    },
    sm: {
      srcSet: picture === null || picture === void 0 ? void 0 : picture.sm
    },
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage,
    alt: picture === null || picture === void 0 ? void 0 : picture.alt
  }))));
};
export default FeatureContent;